import {ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {WebrtcService} from "../../../services/webrtc.service";
import {Chat, IMessengerConnector} from "../../../types/all.type";
import {NotifierWrapService} from "../../../services/notifier-wrap.service";
import {
  MediaPermissionsError,
  MediaPermissionsErrorType,
  requestMediaPermissions
} from 'mic-check';

@Component({
  selector: 'app-modal-video-call-incoming',
  templateUrl: './modal-video-call-incoming.component.html',
  styleUrls: ['./modal-video-call-incoming.component.scss', './../modal-video-calls.component.scss']
})
export class ModalVideoCallIncomingComponent implements OnInit, OnDestroy {
  @Input() Service: IMessengerConnector;
  @Input() chat: Chat;
  @Input() type: 'video' | 'share' | 'audio' = 'video';
  isMute: boolean;
  isVideoDisable: boolean;
  isCall: boolean;
  videoPermission = true;
  micPermission = true;
  testStream: MediaStream;
  @ViewChild('testVideo', {read: ElementRef, static: false}) testVideo: ElementRef<HTMLVideoElement>;
  constructor(
    public cd: ChangeDetectorRef,
    public notifierWrapService: NotifierWrapService,
    public webrtcService: WebrtcService
  ) {
  }

  ngOnInit(): void {
    this.checkPermissions();
    this.notifierWrapService.playAudio('calling', true);
  }

  toggleMute(): void {
    this.isMute = !this.isMute;
    this.cd.detectChanges();
  }

  toggleVideo(): void {
    this.isVideoDisable = !this.isVideoDisable;
    this.cd.detectChanges();

  }

  ngOnDestroy(): void {
    this.notifierWrapService.stopAudio();
  }

  call(): void {
    this.isCall = true;
    this.notifierWrapService.stopAudio();
    this.cd.detectChanges();
  }

  checkPermissions() {
    this.webrtcService.getUserStream(this.type).catch(err => {
      return null;
    }).then((stream: MediaStream) => {
      this.micPermission = !!stream;
      if (!stream) {
        return;
      }
      this.webrtcService.setVideoStream(this.testVideo.nativeElement, stream)

    })
    requestMediaPermissions()
      .then((res) => {
        console.log('requestMediaPermissions', res);
        // can successfully access camera and microphone streams
        // DO SOMETHING HERE
      })
      .catch((err: MediaPermissionsError) => {
        console.log('requestMediaPermissions', err);
        const { type, name, message } = err;
        if (type === MediaPermissionsErrorType.SystemPermissionDenied) {
          // browser does not have permission to access camera or microphone
          alert('browser camera or microphone')
        } else if (type === MediaPermissionsErrorType.UserPermissionDenied) {
          // user didn't allow app to access camera or microphone

          alert('access camera or microphone')
        } else if (type === MediaPermissionsErrorType.CouldNotStartVideoSource) {
          // camera is in use by another application (Zoom, Skype) or browser tab (Google Meet, Messenger Video)
          // (mostly Windows specific problem)
        } else {
          // not all error types are handled by this library
        }
      });
  }
}
